export const signOutActionType = "signOut";
export const forceSignOutActionType = "signOut/force";
